<div class="content">
  <button mat-button routerLink="/" type="button">home</button>
</div>

<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="2%" fxFlexFill>
  <mat-spinner></mat-spinner>
  <h1>U wordt aangemeld, even geduld aub</h1>
  <div routerLink="/" class="clickable">Indien het inloggen te lang duurt, klik hier</div>
</div>